export default __webpack_public_path__ + "static/media/touchTwo.fa42be55.svg";